import React, { PropsWithChildren } from 'react';
import { Control } from 'react-hook-form';

import Dialog from '@/components/template/Dialog';

import { DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';

import BuslineForm, { IBuslineSchema } from '../BuslineForm';

interface IProps extends PropsWithChildren {
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  isLoading: boolean;
  control: Control<IBuslineSchema>;
}

const AddBuslineDialogView: React.FC<IProps> = ({
  onSubmit,
  control,
  isLoading,
  children,
}) => (
  <Dialog
    title="Add Busline"
    description="Add a new busline to the system."
    trigger={children}
  >
    <form onSubmit={onSubmit}>
      <BuslineForm control={control} isLoading={isLoading} />
      <DialogFooter>
        <Button type="submit" disabled={isLoading}>
          {isLoading && <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />}
          Add Busline
        </Button>
      </DialogFooter>
    </form>
  </Dialog>
);

export default AddBuslineDialogView;
